import create from '@verndale/core';
import modules, { global } from './modules';
import {
  handlePersonalizeComponentLoaded,
  initPersonalizeActions,
  PERSONALIZE_COMPONENT_LOADED_EVENT
} from './helpers/personalize';

//Backend dispatch this event when the personalize component is loaded. Code is in personalize platform.
window.addEventListener(
  PERSONALIZE_COMPONENT_LOADED_EVENT,
  handlePersonalizeComponentLoaded
)

initPersonalizeActions();

let modulesCreated = false;
document.addEventListener('DOMContentLoaded', () => {
  if (modulesCreated) return;
  modulesCreated = true;

  global();
  create(modules);
});
